"use strict";

angular.module('PatientApp').service('ProvidersService', function ($q, $log, $resource, $filter, $rootScope, _, endpoints, VuexStore, VueEventTransmitter, Compass) {
  // Register this service to clear it's data when asked to
  VueEventTransmitter.$on('data:clear', function () {
    VuexStore.dispatch('flushProviders');
  });
  VueEventTransmitter.$on('debug:axiosRequest', function (context) {
    Compass.capture.misc('session', 'user', 'axiosInterceptor::onRequest', JSON.stringify(context));
  });
  return {
    flushAcctActivity: function flushAcctActivity(acctNumber) {
      return VuexStore.dispatch('flushAcctActivity', {
        acctNumber: acctNumber
      });
    }
  };
});